// ============================================
// PARALLAX ANIMATION - SILENT VERSION
// ============================================
(function() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        if (document.querySelector('.events-side-image--right')) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: ".events-side-image--right",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1,
                    markers:false
                }
            }).to(".events-side-image--right", {
                y:300,
                ease: "none",
                duration: 1
            });
        }
        if (document.querySelector('.hains-home .section-top-image')) {

            gsap.timeline({

                scrollTrigger: {

                    trigger: ".hains-home .section-top-image",

                    start: "top bottom",

                    end: "bottom top",

                    scrub: 1,

                    markers: false

                }

            }).to(".hains-home .section-top-image", {

                y: 300,

                ease: "none",

                duration: 1

            });


        }
 
    }
})();

/**** 5 aug js */

gsap.fromTo(
  ".parralax-sec .banner__media img",
  {
    y: -80,
    scale: 1.2
  },
  {
    y: 80,
    scale: 1.08,
    ease: "none",
    scrollTrigger: {
      trigger: ".parralax-sec",
      start: "top bottom",
      end: "bottom top",
      scrub: 1.5
    }
  }
);

/*** home banner gsap js  */
gsap.registerPlugin(ScrollTrigger);
const mm = gsap.matchMedia();
mm.add("(min-width: 992px)", () => {
    // Banner Image
    gsap.fromTo(
        ".home-banner .banner-desktop-image",
        {
            y: -120
        },
        {
            y:120,
            ease: "none",
            scrollTrigger: {
                trigger: ".home-banner",
                start: "top bottom",
                end: "bottom top",
                scrub: 1.5
            }
        }
    );

    // Banner Content
    gsap.fromTo(
        ".home-banner .banner__content",
        {
            y: 0
        },
        {
            y: 80,
            ease: "none",
            scrollTrigger: {
                trigger: ".home-banner",
                start: "top bottom",
                end: "bottom top",
                scrub: 1.5
            }
        }
    );

});

/*** octopus GSAP HS  ***/
gsap.registerPlugin(ScrollTrigger);
function octopusAnimation(selector, x, rotation) {
    gsap.fromTo(
        selector,
        {
            y: 60,
            x: x,
            rotation: rotation,
            scale: 1.12
        },
        {
            y: 0,
            x: 0,
            rotation: 0,
            scale: 1,
            ease: "none",
            scrollTrigger: {
                trigger: ".decorative-banner",
                start: "top 85%",
                end: "top 35%",
                scrub: 2,
                invalidateOnRefresh: true
            }
        }
    );

}
octopusAnimation(
    ".decorative-banner__image--left img",
    -15,
    -3
);
octopusAnimation(
    ".decorative-banner__image--right img",
    15,
    3
);



/**** bottle GSAP animation */


gsap.registerPlugin(ScrollTrigger);
gsap.matchMedia().add("(min-width: 992px)", () => {
  ScrollTrigger.create({
    trigger: ".events-section",
    start: "top 90%",
    end: "bottom top",
    scrub: 2,
    onUpdate: (self) => {
      // Animation sirf first 30% progress tak chalegi
      const p = gsap.utils.clamp(0, 0.30, self.progress) / 0.30;
      gsap.set(".events-side-image--right img", {
        y: 35 - (p * 35),
        x: 8 - (p * 8),
        rotation: 1.5 - (p * 1.5)
      });
    }
  });
});


/***hains home sec hom page  */
   
gsap.registerPlugin(ScrollTrigger);
gsap.matchMedia().add("(min-width: 992px)", () => {
  gsap.to(".section-top-image img", {
    y: -35,                 // bahut subtle movement
    ease: "none",
    scrollTrigger: {
      trigger: ".hains-home",
      start: "top bottom",
      end: "bottom top",
      scrub: 6
    }
  });
});


/** quater section bottom image   */
/*
gsap.registerPlugin(ScrollTrigger);

gsap.matchMedia().add("(min-width: 992px)", () => {

  gsap.fromTo(
    ".quaters-sctn .bottom_image img",
    {
      y: 50
    },
    {
      y: -40,
      ease: "none",
      scrollTrigger: {
        trigger: ".quaters-sctn",
        start: "top bottom",
        end: "bottom top",
        scrub: 5,
        invalidateOnRefresh: true
      }
    }
  );

});
*/

gsap.registerPlugin(ScrollTrigger);

gsap.matchMedia().add("(min-width: 992px)", () => {

  const img = document.querySelector(".quaters-sctn .bottom_image");

  ScrollTrigger.create({
    trigger: ".quaters-sctn",
    start: "top bottom",
    end: "bottom top",
    scrub: 1,
    invalidateOnRefresh: true,

    onUpdate: self => {

      // progress 0 → 1
      const p = self.progress;

      // smooth easing
      const eased = gsap.parseEase("power2.out")(p);

      gsap.set(img, {
        y: gsap.utils.interpolate(180, -120, eased)
      });

    }
  });

});
/*** wisky home banner */

 
gsap.registerPlugin(ScrollTrigger);

gsap.matchMedia().add("(min-width: 992px)", () => {

  gsap.fromTo(
    ".whisky-home-banner .bottom_image",
    {
      yPercent: 25
    },
    {
      yPercent: -25,
      ease: "none",
      scrollTrigger: {
        trigger: ".whisky-home-banner",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true
      }
    }
  );

});

/* Contact Banner */
// gsap.fromTo(
//   ".full-img-banner-cigars .banner__media img",
//   {
//     y: -80,
//     scale: 1.2
//   },
//   {
//     y: 80,
//     scale: 1.08,
//     ease: "none",
//     scrollTrigger: {
//       trigger: ".full-img-banner-cigars",
//       start: "top bottom",
//       end: "bottom top",
//       scrub: 1.5
//     }
//   }
// );

gsap.fromTo(
    ".full-img-banner-cigars .banner__media img",
    {
        xPercent: -5,
        scale: 1.2
    },
    {
        xPercent: 5,
        scale: 1.2,
        ease: "none",
        scrollTrigger: {
            trigger: ".full-img-banner-cigars",
            start: "top bottom",
            end: "bottom top",
            scrub: 1.5
        }
    }
);
// gsap.fromTo(
//   ".whisky-collection .image-with-text__media-item img",
//   {
//     y: -80,
//     scale: 1.2
//   },
//   {
//     y: 80,
//     scale: 1.08,
//     ease: "none",
//     scrollTrigger: {
//       trigger: ".whisky-collection",
//       start: "top bottom",
//       end: "bottom top",
//       scrub: 1.5
//     }
//   }
// );

gsap.fromTo(
  ".whisky-collection .top-img-aq img",
  {
    y: -100
  },
  {
    y: 100,
    ease: "none",
    scrollTrigger: {
      trigger: ".whisky-collection",
      start: "top bottom",
      end: "bottom top",
      scrub: 1.5
    }
  }
);
gsap.fromTo(
  ".whisky-collection .bottom-img-aq img",
  {
    y: -100
  },
  {
    y: 100,
    ease: "none",
    scrollTrigger: {
      trigger: ".whisky-collection",
      start: "top bottom",
      end: "bottom top",
      scrub: 1.5
    }
  }
);